import { render, staticRenderFns } from "./product-details-alerts.vue?vue&type=template&id=3b0423da&scoped=true&"
import script from "./product-details-alerts.vue?vue&type=script&lang=js&"
export * from "./product-details-alerts.vue?vue&type=script&lang=js&"
import style0 from "./product-details-alerts.vue?vue&type=style&index=0&id=3b0423da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0423da",
  null
  
)

export default component.exports